const emailValidation = emailInput => {
  const email = emailInput.toLowerCase().trim()
  // eslint-disable-next-line
  const emailRegex = /^[^\s@]+@[a-zA-Z\-0-9]+\.[^\s@]{2,4}$/
  return emailRegex.test(email)
}

export default emailValidation
